import { errorMessage } from '@helpers/Constants';
import { OrderNotesModalProps } from '@helpers/Models';

export const OrderNotesModal: React.FC<OrderNotesModalProps> = ({
  speciesName,
  onClose,
  checkInNotes,
  AdditionalNotes,
  ServiceNotes = [],
  ProductNotes = [],
}) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white w-full max-w-md rounded-lg shadow-lg flex flex-col max-h-[80vh]">
        {/* Sticky Header */}
        <div className="sticky top-0 bg-white z-10 border-b px-6 py-3">
          <div className="flex justify-between items-center">
            <h2 className="text-lg font-bold">{speciesName} Notes</h2>
            <button
              type="button"
              onClick={onClose}
              className="text-gray-600 hover:text-gray-900"
            >
              ✕
            </button>
          </div>
        </div>
        <div className="overflow-y-auto px-6 py-2 flex-1">
          <div className="borber-b">
            <div className="text-left w-full p-3 mt-3 cursor-pointer bg-[#ECECEC]/35">
              <h3 className="mb-2 font-medium text-gray-800">
                Checkin Notes :
              </h3>
              <span className="text-[#5A5A5A]">
                {checkInNotes ?? errorMessage.NO_NOTES_FOUND}
              </span>
            </div>
            <div className="text-left w-full p-3 mt-3 cursor-pointer bg-[#ECECEC]/35">
              <h3 className="mb-2 font-medium text-gray-800">
                Additional Notes :
              </h3>
              <span className="text-[#5A5A5A]">{AdditionalNotes}</span>
            </div>
          </div>
          {ServiceNotes.length > 0 && (
            <>
              <h3 className="mb-2 mt-2 p-0.5 text-gray-800 font-medium text-left">
                Service Notes
              </h3>
              {ServiceNotes.map((notes, index) => (
                <div key={index} className="border-b">
                  <div className="text-left w-full p-3 mt-3 cursor-pointer bg-[#ECECEC]/35">
                    <ul className="text-[#5A5A5A] space-y-1 list-disc list-inside">
                      <div>
                        <div className="font-medium text-gray-800">
                          {notes.serviceName}
                        </div>
                        <div className="text-[#5A5A5A]">
                          {notes.note
                            ? notes.note
                            : errorMessage.NO_NOTES_FOUND}
                        </div>
                      </div>
                    </ul>
                  </div>
                </div>
              ))}
            </>
          )}
          {ProductNotes.length > 0 && (
            <>
              <h3 className="mb-2 mt-2 p-0.5 text-gray-800 font-medium text-left">
                Product Notes
              </h3>
              {ProductNotes.map((notes, index) => (
                <div key={index} className="border-b">
                  <div className="text-left w-full p-3 mt-3 cursor-pointer bg-[#ECECEC]/35">
                    <ul className="text-[#5A5A5A] space-y-1 list-disc list-inside">
                      <div>
                        <div className="font-medium text-gray-800">
                          {notes.productName}
                        </div>
                        <div className="text-[#5A5A5A]">
                          {notes.note
                            ? notes.note
                            : errorMessage.NO_NOTES_FOUND}
                        </div>
                      </div>
                    </ul>
                  </div>
                </div>
              ))}
            </>
          )}
        </div>
      </div>
    </div>
  );
};
